import Gallery from '@jetshop/ui/Gallery/Gallery';
import Badges from '@jetshop/ui/ProductList/Badges';
import React from 'react';
import { css, cx } from 'linaria';
import { useSwitchToVariantImage } from '@jetshop/core/hooks/Product';
import { theme } from '../../Theme';
import CustomBadges from '../../ui/CustomBadges';

const wrapper = css`
  display: flex;
  flex-direction: column;
  img {
    /* object-fit: cover !important; */
  }

  .image-gallery-right-nav {
    display: none;
  }
  .image-gallery-left-nav {
    display: none;
  }

  /* .image-gallery-thumbnails-container {
    display: flex;
  } */

  .image-gallery-thumbnails-wrapper {
    width: 70px;

    ${theme.below.lg} {
      display: none;
    }
  }

  .image-gallery-slide-wrapper {
    width: 100%;
  }

  .image-gallery-thumbnails {
    justify-content: flex-start !important;
  }

  .image-gallery-fullscreen-button {
    display: none;
  }

  .image-gallery-thumbnail {
    border: none;
    width: 60px;
    margin-bottom: 10px;
    &.active {
      border: none;
      margin-bottom: 10px;
    }

    img {
      /* object-fit: cover !important; */
    }
  }

  .image-gallery-thumbnail + .image-gallery-thumbnail {
    margin-left: 10px;
  }

  &.has-thumbnails {
    .image-gallery-slide-wrapper {
      width: calc(100% - 76px);
      ${theme.below.lg} {
        width: 100%;
      }
    }
  }

  ${theme.below.lg} {
    .image-gallery-image {
      border-left: 1px solid ${theme.colors.border};
    }

    .image-gallery-slide {
      &.right {
        margin-left: -20px;
      }
    }
  }
`;

export default function ImageContainer({ images, badges, variant, ...rest }) {
  const galleryRef = React.createRef();
  // Enable switching gallery to image of selected variant
  useSwitchToVariantImage({
    galleryImages: images,
    galleryRef,
    variant
  });

  const selectedVariantImageIndex = variant
    ? images.findIndex(image => image.url === variant.images?.[0]?.url)
    : null;

  const hasMultipleImages = images?.length > 1;

  return (
    <div
      {...rest}
      className={cx(
        rest.className,
        wrapper,
        hasMultipleImages && 'has-thumbnails'
      )}
    >
      <Gallery
        aspect={'1:1'}
        images={images}
        galleryRef={galleryRef}
        thumbnailPosition={'left'}
        eagerlyLoad={
          selectedVariantImageIndex ? [0, selectedVariantImageIndex] : [0]
        }
      >
        {badges && <CustomBadges badges={badges} />}
        {/* <Badges badges={badges} /> */}
      </Gallery>
    </div>
  );
}
